import { NumberFormatKinds } from "./NumberFormatKinds";
import { INumberStyle } from "./INumberStyle";

export class NumberStyle {
  constructor(
    public formatKind: NumberFormatKinds,
  ) {
  }
  
  clone(): NumberStyle {
    return new NumberStyle(this.formatKind);
  }

  static from(source: INumberStyle): NumberStyle {
    return new NumberStyle(source.formatKind);
  }

  static to(source: NumberStyle): INumberStyle {
    return {
      formatKind: source.formatKind,
    };
  }
}
